<script>
  import { onMount, onDestroy } from 'svelte';
  import AuthenticatedLayout from '../../app-shell/authorized-app/Layout.svelte';
  import Tabs from '../../lib/workpilots-ui/Tabs.svelte';
  import { t9n } from '../../lib/translate';
  import { TS } from '../../config/translation-keys';

  export let machine;
  export let items;
  export let app_context;

  let button_back_to_payment_and_reports = t9n(TS.BUTTON_BACK_TO_PAYMENT_AND_REPORTS)

  $: {
    machine.update_context(app_context);
    app_context = machine.context;
  }

  const set_active_tab = function(e) {
    let id = e ? e.detail.id : items[0].id;
    items = items.map(i => {
      return { ...i, context: { ...i.context, active: i.id === id } };
    });
    // animateHeight();
  };

  // Animate container card size change

  const animateHeight = () => {
    let inner = document.querySelector('#transition-inner');
    let innerHeight = inner.clientHeight;
    let outer = document.querySelector('#transition-outer');
    outer.style.height = innerHeight + 'px';
  };

  export const update = (
    updated_context = app_context,
    updated_items = items
  ) => {
    app_context = updated_context;
    items = updated_items;
    set_active_tab();
  };

  export const destroy = () => {};

  onMount(() => {
    document
      .querySelector('.mdc-top-app-bar--fixed-adjust')
      .scrollIntoView({ behavior: 'smooth' });
    set_active_tab(false);
    // animateHeight();
  });

  // onDestroy(machine.destroy);
</script>

<!--<AuthenticatedLayout-->
<!--  config={app_context.config}-->
<!--  route_name={app_context.route_name}>-->
<main id="transition-outer" class="wrapper fade-in transition-main">
  <div id="transition-inner">

    <Tabs
      bind:items
      on:ppbuy={update}
      on:ppdonate={update}
      on:ppclaim={update}
      on:tabactivated={set_active_tab} />

    <div style='text-align: center'>
      <a
        data-link={true}
        href={`/cards`}
        style="margin-bottom:10px; margin-top: 5px;"
        data-mdc-dialog-initial-focus
        class="btn-close mdc-button mdc-button--unelevated">
        <span class="mdc-button__ripple" />
        {button_back_to_payment_and_reports}
      </a>
    </div>
  </div>


</main>
<!--</AuthenticatedLayout>-->

<style>
  main {
    display: flex;
    flex-direction: column;
    margin-top: 3rem !important;
    padding: 1rem 1rem;
    background: #fff;
    border-radius: 10px;
    -webkit-box-shadow: var(--global-box-shadow);
    -moz-box-shadow: var(--global-box-shadow);
    box-shadow: var(--global-box-shadow);
  }

  .pilotpoints {
    width: 80%;
    margin: 3rem auto 20px auto;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
    box-sizing: border-box;
    font-family: 'Open Sans', sans-serif;
    color: #7a7676;
    line-height: 20px;
    overflow-x: hidden;
    font-size: 18px;
    font-weight: 200;
    padding: 1.5em;
  }

  .breadcrumb {
    margin: 1.2em;
    display: none;
  }

  #transition-inner {
    /*width: 850px;*/
    /*  max-height: 900px;*/
    /*  transition: max-height 0.25s ease-in;*/
    overflow: hidden;
  }

  /* Desktop Mode
    *******************************************************/
  @media (min-width: 1025px) {
    .wrapper {
      width: 900px;
      margin: 0 auto;
      margin-bottom: 50px;
      height: fit-content;
    }
  }

  /* Tablet Mode
    *******************************************************/
  @media (min-width: 769px) and (max-width: 1024px) {
    .wrapper {
      width: 90%;
      margin: 0 auto;
      margin-left: 50px;
      margin-bottom: 50px;
      height: fit-content;
    }
  }

  /* Mobile Mode
    *******************************************************/
  @media (min-width: 0) and (max-width: 768px) {
    .wrapper {
      /*width: 100%;*/
      margin: 0 auto;
      margin-left: 50px;
      margin-bottom: 50px;
      height: fit-content;
    }

    .transition-main {
      transition: height 0.3s;
      overflow: visible;
    }
  }
</style>
